/* eslint-disable react/prop-types */
/* eslint-disable import/prefer-default-export */
import React from 'react'

export function SearchIcon({ className }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_1096_9636)">
        <path
          d="M7 12C9.76142 12 12 9.76142 12 7C12 4.23858 9.76142 2 7 2C4.23858 2 2 4.23858 2 7C2 9.76142 4.23858 12 7 12Z"
          stroke="#ECECEC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M10.5356 10.5356L14 14" stroke="#ECECEC" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_1096_9636">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
